import React, { useEffect, useState } from "react";

function SectionMySkills() {
	const [skills, setSkills] = useState([]);

	useEffect(() => {
		const data = [
			{
				skill: "UI/UX Design",
				level: 90,
			},
			{
				skill: "Front-End Developer",
				level: 95,
			},
			{
				skill: "Graphic Design",
				level: 90,
			},
			{
				skill: "Product Design",
				level: 85,
			},
		];

		setSkills(data);
	}, []);

	return (
		<section id="my-skills">
			<div className="bg-extralight py-20">
				<div className="container">
					<div className="grid gap-12 lg:grid-cols-2 lg:gap-24">
						<div>
							<div className="mb-3 flex items-center gap-2 lg:gap-6">
								<h1 className="section-title__number">02</h1>
								<h3 className="section-title__text">My Skills</h3>
							</div>
							<p className="mb-8 font-montserrat text-xs font-medium leading-8 text-grey lg:text-sm">
								Lorem ipsum, dolor sit amet consectetur adipisicing elit.
								Itaque, praesentium voluptatibus pariatur perferendis sint
								similique iure deserunt! Architecto asperiores deserunt cumque
								mollitia possimus quae placeat.
							</p>
							<button className="btn-main font-semibold uppercase">
								Download CV
							</button>
						</div>
						<div className="self-center">
							<div className="flex flex-col gap-8">
								{skills.map((item, index) => (
									<div key={index}>
										<div className="mb-3 flex justify-between">
											<h5 className="font-montserrat text-sm font-semibold">
												{item.skill}
											</h5>
											<h5 className="font-montserrat text-sm font-semibold">
												{item.level}%
											</h5>
										</div>
										<div className="relative h-[6px] rounded-3xl bg-[#DDDEE0]">
											<div
												className="absolute h-full rounded-3xl bg-main"
												style={{ width: `${item.level}%` }}
											/>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}

export default SectionMySkills;
